import { render, staticRenderFns } from "./SubOrder.vue?vue&type=template&id=6773bfa9&scoped=true&"
import script from "./SubOrder.vue?vue&type=script&lang=js&"
export * from "./SubOrder.vue?vue&type=script&lang=js&"
import style0 from "./SubOrder.vue?vue&type=style&index=0&id=6773bfa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773bfa9",
  null
  
)

export default component.exports